// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { NodeEdge } from "@hex-insights/app-modules";
import { FieldInputOption } from "@hex-insights/forms";
import { Maybe, TrustedDevice, TrustedDeviceNameFragment } from "../../../Utilities";
import { TrustedDeviceFormat } from "../../Format";

/**
 * A slim version of the TrustedDevice model for use in select fields.
 */
export type ModelForOption = Pick<TrustedDevice, "id"> & TrustedDeviceNameFragment;

/**
 * Converts the given `edges` to options to be given to a radio or select field.
 *
 * @param edges The edges to convert to options.
 * @param current The current instance for the field. Used to display when `edges` is blank (e.g. with lazy loading).
 */
export function toOptions(edges?: NodeEdge<ModelForOption>[], current?: Maybe<ModelForOption>) {
	if (edges === undefined) {
		if (!(current === null || current === undefined)) {
			return [toOption(current)];
		}
		return [];
	}
	return edges.map((e) => toOption(e.node));
}

/**
 * Converts the given `edges` to options to be given to a multi-select field.
 *
 * @param edges The edges to convert to options.
 * @param current The current instances for the field. Used to display when `edges` is blank (e.g. with lazy loading).
 */
export function toMultiOptions(edges?: NodeEdge<ModelForOption>[], currents?: ModelForOption[]) {
	if (edges === undefined) {
		if (currents !== undefined) {
			return currents.map(toOption);
		}
		return [];
	}
	return edges.map((e) => toOption(e.node));
}

/**
 * Converts a single TrustedDevice instance to an option to be given to a radio, select, or
 * multi-select field.
 *
 * @param instance The instance to convert to an option.
 */
export function toOption(instance: ModelForOption): FieldInputOption<TrustedDevice["id"]> {
	return {
		label: TrustedDeviceFormat.name(instance),
		value: instance.id,
	};
}
